module.exports = __webpack_public_path__ + "img/3.f02a4653.png";